import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { useLang } from "../context/LanguageContext";
import { Reveal } from "./Reveal";
import { Mail, ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NewsletterSignup = () => {
  const { t } = useLang();
  const nl = t.newsletter;
  const [email, setEmail] = useState("");
  const [hp, setHp] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter/subscribe`, { email, hp });
      toast.success(nl.success);
      setEmail("");
    } catch {
      toast.error(nl.error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="newsletter" className="py-20 md:py-28 relative z-10">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal>
          <div className="rounded-3xl bg-primary text-primary-foreground p-8 md:p-14 grid lg:grid-cols-2 gap-8 items-center overflow-hidden relative">
            <div className="absolute -right-16 -top-16 w-64 h-64 rounded-full bg-accent/20 blur-2xl" />
            <div className="relative">
              <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-accent mb-4">
                <Mail size={14} /> {nl.tag}
              </span>
              <h2 className="font-display font-extrabold tracking-tight text-3xl md:text-5xl leading-[1.02] mb-3">{nl.title}</h2>
              <p className="text-primary-foreground/80 max-w-md">{nl.subtitle}</p>
            </div>
            <form data-testid="newsletter-form" onSubmit={submit} className="relative flex flex-col sm:flex-row gap-3">
              <input type="text" tabIndex={-1} autoComplete="off" value={hp} onChange={(e) => setHp(e.target.value)} className="hidden" aria-hidden="true" />
              <input
                data-testid="newsletter-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={nl.placeholder}
                className="flex-1 bg-white/10 border border-white/25 rounded-full px-5 py-3.5 text-sm font-medium outline-none focus:border-accent focus:bg-white/15 transition-all placeholder:text-primary-foreground/50"
              />
              <button
                data-testid="newsletter-submit"
                type="submit"
                disabled={loading}
                className="inline-flex items-center justify-center gap-2 bg-accent text-accent-foreground font-semibold rounded-full px-7 py-3.5 hover:brightness-95 active:scale-95 transition-all disabled:opacity-60 whitespace-nowrap"
              >
                {loading ? nl.sending : nl.button}
                <ArrowRight size={17} />
              </button>
            </form>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
